import * as Yup from "yup";

const AddressFormSchema = () => {
  return Yup.object().shape({
    alias: Yup.string()
      .min(3, "Alias musi mieć co najmniej 3 znaki")
      .max(20, "Alias może mieć maksymalnie 20 znaków")
      .required("Alias jest wymagany"),

    firstName: Yup.string()
      .min(3, "Imię musi mieć co najmniej 3 znaki")
      .max(20, "Imię może mieć maksymalnie 20 znaków")
      .required("Imię jest wymagane"),
    lastName: Yup.string()
      .min(3, "Nazwisko musi mieć co najmniej 3 znaki")
      .max(20, "Nazwisko może mieć maksymalnie 20 znaków")
      .required("Nazwisko jest wymagane"),
    address1: Yup.string()
      .min(3, "Adres musi mieć co najmniej 3 znaki")
      .max(50, "Adres może mieć maksymalnie 20 znaków")
      .required("Adres jest wymagany"),
    address2: Yup.string()
      .min(1, "Numer domu musi mieć co najmniej 1 znak")
      .max(50, "Numer domu może mieć maksymalnie 50 znaków")
      .required("Numer domu jest wymagany"),
    postcode: Yup.string()
      .matches(/^\d{2}-\d{3}$/, "Kod pocztowy musi być w formacie XX-XXX")
      .required("Kod pocztowy jest wymagany"),
    city: Yup.string()
      .min(3, "Miasto musi mieć co najmniej 3 znaki")
      .max(50, "Miasto może mieć maksymalnie 20 znaków")
      .required("Miasto jest wymagane"),
    phone: Yup.string()
      .max(20, "Telefon może mieć maksymalnie 20 znaków")
      .matches(
        /^\+\d{2} \d{3} \d{3} \d{3}$/,
        "Telefon musi być w formacie +48 XXX XXX XXX",
      )
      .required("Telefon jest wymagany"),
    companyAddress: Yup.boolean(),
    company: Yup.string().when("companyAddress", {
      is: true,
      then: Yup.string()
        .min(3, "Firma musi mieć co najmniej 3 znaki")
        .max(50, "Firma może mieć maksymalnie 50 znaków")
        .required("Firma jest wymagana"),
    }),
    vatNumber: Yup.string().when("companyAddress", {
      is: true,
      then: Yup.string()
        .max(10, "NIP może mieć maksymalnie 20 znaków")
        .required("NIP jest wymagany"),
    }),
  });
};

export default AddressFormSchema;
